import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Avatar, Box, Button, ButtonGroup, Chip, IconButton, Menu, Typography, UserAvatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AssistantChatKind } from 'shared/domains/apollo/generated/types';
import { useAccount } from 'shared/domains/users';
import { ContentContainer } from './ContentContainer';
import { MarkdownContent } from './MarkdownContent';
import { TabularContent } from './TabularContent';
import { usePromptLibrary } from '../../../PromptLibraryProvider';
import { Container } from './styled';
export function Item(props) {
    var _a, _b, _c;
    const { onSelect, setCurrentPromptID, setView } = usePromptLibrary();
    const { prompt } = props;
    const [open, setOpen] = useState(false);
    const account = useAccount();
    const { userId } = account.data;
    const usernameFallback = t({ message: 'Deleted user', comment: 'Fallback name when user does not exist' });
    const promptUserName = ((_b = (_a = prompt.createdByUser) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.split(' ')[0]) || usernameFallback;
    return (<Container role="button">
      <Box>
        <Typography $fontSize="large" $fontWeight="bold">
          {prompt.name}
        </Typography>

        <Box ml="auto" pl="xl">
          <ButtonGroup>
            <Button onClick={() => onSelect(prompt)} appearance="secondary" size="xs">
              <Trans comment="Prompt library - Select prompt button">Select</Trans>
            </Button>
            {userId === ((_c = prompt.createdByUser) === null || _c === void 0 ? void 0 : _c.id) && (<Menu.Root target={<IconButton appearance="secondary" size="xs" onClick={() => setOpen(!open)}>
                    <Falcon icon="ellipsis-v"/>
                  </IconButton>}>
                <Menu.Item onClick={() => {
                setCurrentPromptID(prompt.id);
                setView('edit');
            }}>
                  <Falcon icon="pen"/>
                  <Trans comment="Prompt library - Edit prompt button">Edit</Trans>
                </Menu.Item>
                <Menu.Item onClick={() => {
                setCurrentPromptID(prompt.id);
                setView('confirmDelete');
            }}>
                  <Falcon icon="trash"/>
                  <Trans comment="Prompt library - Delete prompt button">Delete</Trans>
                </Menu.Item>
              </Menu.Root>)}
          </ButtonGroup>
        </Box>
      </Box>

      <ContentContainer promptId={prompt.id}>
        {prompt.kind === AssistantChatKind.Regular && <MarkdownContent content={prompt.content}/>}
        {prompt.kind === AssistantChatKind.Tabular && <TabularContent content={prompt.content}/>}
      </ContentContainer>

      <Box pt="xl" mt="auto" justifyContent="flex-end" alignItems="center" gap="md">
        {prompt.kind === AssistantChatKind.Tabular && <Chip label="Tabular" appearance="info"/>}

        {prompt.isSystemPrompt ? (<Avatar size="xs" solid appearance="secondary">
            <Falcon icon="book-open"/>
          </Avatar>) : (<UserAvatar title={promptUserName} size="xs"/>)}
      </Box>
    </Container>);
}
